<template>
    <div class="mt-5 w-full gc-cmp-form-select">

        <div :class="tipClass" v-show="showTip" style="transition-delay: 0s;">请选择</div>
        <label
                v-if="labelPlaceholder?false:label"
                class="vs-input--label"
                @click="focusInput">{{ label }}</label>
        <v-select v-model="selected" :options="getOptions" :placeholder="getSelectPlaceholder"
                  autocomplete="on" @input="onSelected"
                  :reduce="opt => opt.id"
                  ref="the_select"
                  :disabled="disabled"
        >
            <div slot="no-options">暂无选项</div>

        </v-select>


    </div>
</template>
<script>

    import vSelect from 'vue-select';

    export default {
        name:'gc-cmp-form-select',
        components: {
            'v-select': vSelect,
        },
        model: {
            prop: 'outSelect',
            event: 'input'
        },
        props:{
            labelPlaceholder:{
                default:null,
                type:[String,Number]
            },
            selectPlaceholder:{
                default:null,
                type:[String]
            },
            label:{
                default:null,
                type:[String,Number]
            },
            outSelect:{
                default:'',
                type:[String,Number]
            },
            options: {
                type: Array,
                required: true
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data:()=>({
            timer: null,
            showTip: false,
            localOptions: [],
            selected: [],
        }),
        watch: {
            outSelect: function (val) {
                // console.log(['----outSelect-value-changed', val]);
                this.autoSelect();
            },
            selected: function (val) {
                // console.log(['select-value-changed', val]);
            },
            options: function (val) {
                // console.log(['select-watch-options', val]);
                this.init();
            }
        },
        computed:{
            tipClass() {
                let ret = 'vs-tooltip vs-tooltip-left vs-tooltip-danger';
                return ret;
            },
            getSelectPlaceholder() {
                return  this.selectPlaceholder || this.labelPlaceholder || '';
            },
            getOptions() {
                return  this.localOptions;
            }
        },
        methods: {
            onSelected(payload) {
                this.fireToParent(payload);
            },
            startTipTimer() {
                this.timer = setTimeout(() => {
                    this.showTip = false;
                }, 1000);
            },
            clearTipTimer() {
                if (this.timer) { clearTimeout(this.timer); }
            },
            fireToParent(payload) {
                this.$emit('input', payload);
            },
            focusInput() {
                this.$refs.the_select.onSearchFocus();
                let input = this.$el.querySelector('input');
                if (input) { input.focus(); }
                this.showTip = true;
                this.startTipTimer();
            },
            autoSelect() {

                this.selected = [];

                let _out_sel = this.outSelect + '';

                let idx, map = {}, optIdx;
                if (_out_sel.length < 1) { return; }

                let input_is_array = Array.isArray(_out_sel);

                let input_selected = input_is_array ? _out_sel : [_out_sel];

                for (idx = 0; idx < this.localOptions.length; idx++) {
                    map[ this.localOptions[idx].id ] = idx;
                }
                // console.log(['this.localOptions', this.localOptions]);
                // console.log(['map', map]);
                // console.log(['input_selected', input_selected]);

                for (idx = 0; idx < input_selected.length; idx++) {
                    if (undefined !== map[ input_selected[idx] ]) { // value is id
                        optIdx = map[ input_selected[idx] ];
                        this.selected.push( this.localOptions[ optIdx ] );
                    }
                }  // for
                // console.log(['selected', this.selected]);

                if (this.selected.length > 0) {
                    if (!input_is_array) {
                        this.fireToParent(this.selected[0].id);
                    } else {
                        let idx, ids = [];
                        for (idx = 0; idx < this.selected.length; idx++) {
                            if (undefined !== this.selected[idx].id) {
                                ids.push(this.selected[idx].id);
                            }
                        }
                        this.fireToParent(ids);
                    }
                }
            }, // autoSelect
            init() {
                this.localOptions = this.options;
                this.autoSelect();
                this.clearTipTimer();
            }
        },  // methods
        created() {
            this.init();
        }
    }
</script>

<style lang="scss">
    .gc-cmp-form-select {
        position: relative;
        .v-select {
            min-height: 38px;
        }
        .v-select .vs__dropdown-toggle .vs__search {
            font-size: .85rem;
            color: rgba(0,0,0,.4);
            padding: 2px 6px 4px !important;
        }
        .vs-tooltip {
            top: 26px;
            left: 6px;
            width: 70px;
            text-align: center;
        }
    }

</style>
